import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const fractionCalculatorTool: Tool = {
  id: "fraction-calculator",
  name: () => m.fr_tool_name(),
  description: () => m.fr_tool_description(),
  icon: "➗",
  basePath: "/fraction-calculator",
  status: "stable",
  tags: ["education", "math", "fractions", "fraction-calculator"],
};
